/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationSearchRequestModel } from '../../models/organization-search-request-model';
import { OrganizationSearchResultModel } from '../../models/organization-search-result-model';

export interface MedicalAdvisorHealthCareServicesPost$Params {
      body?: OrganizationSearchRequestModel
}

export function medicalAdvisorHealthCareServicesPost(http: HttpClient, rootUrl: string, params?: MedicalAdvisorHealthCareServicesPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<Array<OrganizationSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, medicalAdvisorHealthCareServicesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<Array<OrganizationSearchResultModel>>;
    })
  );
}

medicalAdvisorHealthCareServicesPost.PATH = '/MedicalAdvisor/HealthCareServices';
